import { jwtDecode } from "jwt-decode";

const userData = {
  data() {
    return {
      userData: null,
      userId: null,
      userFullName: null,
      userName: null,
      userLevel: null,
      userAccess: null,
      userToken: null,
      userPhoto: "../assets/img/user.png",
    };
  },
  created() {
    const userData = localStorage.getItem("userData");
    if (userData) {
      this.userData = JSON.parse(userData);
      this.userFullName = this.userData.full_name;
      this.userToken = this.userData.token;
      const decodedToken = jwtDecode(this.userData.token);
      this.userId = decodedToken.id;
      this.userName = decodedToken.username;
      this.userLevel = decodedToken.role;
    }
  },
};

export default userData;
